<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/admin/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索栏和添加权限 -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
          <i :class="isSearchExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          <span>搜索筛选</span>
        </div>
        <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="6">
              <el-input
                placeholder="请输入权限代码"
                v-model="searchCode"
                clearable
                @clear="handleSearch()"
                @keyup.enter.native="handleSearch()"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-input
                placeholder="请输入权限名称"
                v-model="searchName"
                clearable
                @clear="handleSearch()"
                @keyup.enter.native="handleSearch()"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-select
                v-model="searchModule"
                placeholder="请选择模块"
                clearable
                size="medium"
                style="width: 100%;"
                @change="handleSearch"
              >
                <el-option
                  v-for="module in moduleList"
                  :key="module"
                  :label="module"
                  :value="module">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" size="medium" icon="el-icon-plus" @click="showAddPermissionDialog">创建权限</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 权限列表表格 -->
      <div class="table-scroll-wrapper">
        <el-table :data="permissionList" style="width: 100%" border stripe>
        <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
        <el-table-column prop="code" label="权限代码" min-width="180"></el-table-column>
        <el-table-column prop="name" label="权限名称" min-width="150"></el-table-column>
        <el-table-column prop="module" label="所属模块" width="150" align="center">
          <template v-slot="scope">
            <el-tag type="info" size="small">{{ scope.row.module }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" align="center">
          <template v-slot="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template v-slot="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="editPermission(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deletePermission(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </el-card>

    <!-- 创建/编辑权限对话框 -->
    <el-dialog 
      :title="permissionDialogTitle" 
      :visible.sync="showPermissionDialog" 
      width="30%" 
      @close="resetPermissionForm">
      <el-form :model="permissionForm" :rules="permissionRules" ref="permissionFormRef" label-width="100px">
        <el-form-item label="权限代码" prop="code" v-if="!isEditMode">
          <el-input v-model="permissionForm.code" placeholder="格式：模块:操作，如：activity:view"></el-input>
        </el-form-item>
        <el-form-item label="权限代码" v-else>
          <el-input v-model="permissionForm.code" disabled></el-input>
          <div style="font-size: 12px; color: #909399; margin-top: 5px;">
            权限代码创建后不可修改
          </div>
        </el-form-item>
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="permissionForm.name" placeholder="请输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="所属模块" prop="module">
          <el-select v-model="permissionForm.module" placeholder="请选择模块" style="width: 100%;" filterable allow-create>
            <el-option
              v-for="module in moduleList"
              :key="module"
              :label="module"
              :value="module">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPermissionDialog = false">取 消</el-button>
        <el-button type="primary" @click="savePermission">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "Permissions",
  data() {
    return {
      // 权限列表相关
      permissionList: [],
      searchCode: '',
      searchName: '',
      searchModule: '',
      moduleList: [],
      // 对话框相关
      showPermissionDialog: false,
      isEditMode: false,
      permissionDialogTitle: '创建权限',
      permissionForm: {
        id: null,
        code: '',
        name: '',
        module: ''
      },
      isSearchExpanded: false,
      isMobile: false,
      permissionRules: {
        code: [
          { required: true, message: '请输入权限代码', trigger: 'blur' },
          { pattern: /^[a-z_]+:[a-z_]+$/, message: '格式错误，应为：模块:操作', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入权限名称', trigger: 'blur' }
        ],
        module: [
          { required: true, message: '请选择所属模块', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.checkIsMobile();
    this.fetchAllModules()
    this.fetchPermissions()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 获取权限列表
    async fetchPermissions() {
      try {
        const params = {}
        if (this.searchCode) {
          params.code = this.searchCode
        }
        if (this.searchName) {
          params.name = this.searchName
        }
        if (this.searchModule) {
          params.module = this.searchModule
        }
        const res = await this.$http({
          method: 'get',
          url: 'permissions',
          params
        })
        
        // 处理不同的响应格式
        let data = []
        if (res.code === 200) {
          data = res.data || []
        } else if (res.success) {
          data = res.data || []
        } else if (Array.isArray(res)) {
          data = res
        } else if (res.data && Array.isArray(res.data)) {
          data = res.data
        } else {
          console.error('未知的响应格式:', res)
          return this.$message.error(res.message || '获取权限列表失败')
        }
        
        this.permissionList = data
      } catch (err) {
        console.error('获取权限列表错误:', err)
        this.$message.error(err.response?.data?.message || err.message || '获取权限列表失败')
      }
    },
    
    // 显示创建权限对话框
    showAddPermissionDialog() {
      this.isEditMode = false
      this.permissionDialogTitle = '创建权限'
      this.showPermissionDialog = true
    },
    
    // 编辑权限
    editPermission(row) {
      this.isEditMode = true
      this.permissionDialogTitle = '编辑权限'
      this.permissionForm = {
        id: row.id,
        code: row.code,
        name: row.name,
        module: row.module
      }
      this.showPermissionDialog = true
    },
    
    // 保存权限（创建或更新）
    savePermission() {
      this.$refs.permissionFormRef.validate(async (valid) => {
        if (!valid) return
        
        try {
          if (this.isEditMode) {
            // 更新权限
            const res = await this.$http({
              method: 'patch',
              url: `permissions/${this.permissionForm.id}`,
              data: {
                name: this.permissionForm.name,
                module: this.permissionForm.module
              }
            })
            
            if (res.code !== 200 && !res.success) {
              return this.$message.error(res.message || '更新权限失败')
            }
            
            this.$message.success('更新权限成功')
          } else {
            // 创建权限
            const res = await this.$http({
              method: 'post',
              url: 'permissions',
              data: {
                code: this.permissionForm.code,
                name: this.permissionForm.name,
                module: this.permissionForm.module
              }
            })
            
            if (res.code !== 200 && !res.success) {
              return this.$message.error(res.message || '创建权限失败')
            }
            
            this.$message.success('创建权限成功')
          }
          
          this.showPermissionDialog = false
          this.fetchPermissions()
        } catch (err) {
          console.error('保存权限错误:', err)
          this.$message.error(err.response?.data?.message || err.message || '操作失败')
        }
      })
    },
    
    // 删除权限
    deletePermission(id) {
      this.$confirm('此操作将永久删除该权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 注意：API文档中没有删除权限的接口，这里可能需要后端实现
          // 如果后端没有实现，可以提示用户
          this.$message.warning('删除权限功能需要后端支持，请联系开发人员')
          // 如果有删除接口，可以这样调用：
          // const res = await this.$http({
          //   method: 'delete',
          //   url: `/permissions/${id}`
          // })
          // if (res.code !== 200) {
          //   return this.$message.error(res.message || '删除权限失败')
          // }
          // this.$message.success('删除权限成功')
          // this.fetchPermissions()
          // this.fetchAllPermissions()
        } catch (err) {
          this.$message.error(err.response?.data?.message || '删除权限失败')
        }
      }).catch(() => {})
    },
    
    // 重置权限表单
    resetPermissionForm() {
      this.$refs.permissionFormRef && this.$refs.permissionFormRef.resetFields()
      this.permissionForm = {
        id: null,
        code: '',
        name: '',
        module: ''
      }
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')
      const ss = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    
    // 搜索
    handleSearch() {
      this.fetchPermissions()
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },

    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    handleResize() {
      this.checkIsMobile();
    },
    
    // 获取所有模块列表（用于下拉选择）
    async fetchAllModules() {
      try {
        const res = await this.$http({
          method: 'get',
          url: 'permissions',
          params: {} // 不带任何筛选条件，获取所有权限
        })
        
        // 处理不同的响应格式
        let data = []
        if (res.code === 200) {
          data = res.data || []
        } else if (res.success) {
          data = res.data || []
        } else if (Array.isArray(res)) {
          data = res
        } else if (res.data && Array.isArray(res.data)) {
          data = res.data
        } else {
          console.error('未知的响应格式:', res)
          return
        }
        
        // 提取模块列表
        const modules = new Set()
        data.forEach(p => {
          if (p.module) modules.add(p.module)
        })
        this.moduleList = Array.from(modules).sort()
      } catch (err) {
        console.error('获取模块列表错误:', err)
      }
    }
  }
}
</script>

<style scoped>
.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

.el-table {
  overflow-x: auto;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .el-table {
    font-size: 11px;
    overflow-x: auto;
    display: block;
  }

  .el-table th,
  .el-table td {
    padding: 8px 5px !important;
  }

  .el-table .el-button--mini {
    font-size: 10px;
  }

  .el-dialog {
    width: 95% !important;
    margin: 0 auto;
    top: 5vh;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-input__inner {
    font-size: 13px;
    height: 34px;
  }
}
</style>

